import Vue from "vue";
import vuetify from "../vuetify.js";
import TestimonialApp from "../components/contact/TestimonialApp.vue";
import depsloader from "../depsloader";

export default function() {
  const element = document.querySelector("#vue-testimonial");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);
      new Vue({
        el: element,

        components: {
          TestimonialApp
        },

        vuetify: vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(TestimonialApp)
      });
    });
  }
}

